// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c7512754","635":"ea644249"}[chunkId] + ".chunk.js";
};